import state from './state'

/**
 * @description
 * Check if user is authenticated with state data (from local storage)
 *
 * @param {@object} state with state data of auth module
 * @return {boolean} true is authenticated, false otherwise
 */
const isAuthenticated = state => !!state.token

/**
 * @description
 * Get status of user (success, error or loading)
 *
 * @param {object} state with state data of auth module
 * @return {string}
 */
const authStatus = state => state.status

const branchOfficeID = state => {
    return JSON.parse(state.user).g_branch_office_id || null
}

const isGroundSeller = state =>
    state.posWorkstationType && state.posWorkstationType.id === 2

const isCallCenter = state =>
    state.posWorkstationType && state.posWorkstationType.id === 3

const isPriceInfo = state =>
    state.posWorkstationType && state.posWorkstationType.id === 4

const groundSellerId = state =>
    state.groundSeller ? state.groundSeller.id : null

const groundSellerCode = state =>
    state.groundSeller ? state.groundSeller.auth_code : null

export default {
    isAuthenticated,
    authStatus,
    branchOfficeID,
    isGroundSeller,
    isPriceInfo,
    groundSellerId,
    groundSellerCode,
    isCallCenter,
}
